import { connectRouter } from 'connected-react-router/immutable'
import { combineReducers } from 'redux'

import click from './click/click-reducer'
import error from './error/error-reducer'
import plan from './plan/plan-reducer'
import requesting from './requesting/requesting-reducer'
import ui from './ui/ui-root-reducer'
import onboarding from './onboarding/onboarding-root-reducer'

const RootReducer = history => {
  const reducerMap = {
    router: connectRouter(history),
    click,
    error,
    requesting,
    ui,
    onboarding,
    plan,
  }

  return combineReducers(reducerMap)
}

export default RootReducer
